import Vue from "vue";
import VueRouter from "vue-router";
import deviceMissing from "../views/device-missing.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/device-missing",
    name: "deviceMissing",
    component: deviceMissing,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
